<template>
    <div class="step" v-if="type === 'flat'">
        <div class="row">
            <div class="col-md-6">
                <div class="form-group row align-items-center">
                    <label for="floor" class="col-lg-6">{{ $t('parameters.form.names.floor') }}</label>
                    <div class="col-lg-6">
                        <select id="floor" type="number" name="floor" class="custom-select w-100" v-model="floorFlat">
                            <option value="-1">{{ $t('parameters.form.floors.basement') }}</option>
                            <option value="1">{{ $t('parameters.form.floors.first_floor') }}</option>
                            <option v-for="i in 29" :value="i + 1">{{ i + 1 }}. {{ $t('parameters.form.floors.floor') }}</option>
                        </select>
                    </div>
                </div>
                <div class="form-group row align-items-center">
                    <label for="total_floors" class="col-lg-6">{{ $t('parameters.form.names.total_floors') }}</label>
                    <div class="col-lg-6">
                        <select id="total_floors" type="number" name="total_floors" class="custom-select w-100"
                                v-model="floorTotal">
                            <option v-for="i in 29" :value="i">{{ i }}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-md-6 focused-input-image">
                <object class="img-fluid" type="image/svg+xml" :data="assetsUrl + '/floor/floors.svg'"></object>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Floor",

        props: ['assetsUrl'],

        data: function() {
            return {
                floorFlat: null,
                floorTotal: null,
            }
        },

        computed: {
            type: function () {
                let type = this.$parent.getType();
                if (type == "cottage" || type == "hut") {
                    type = "house";
                }

                return type;
            },

            picture: function () {
                if (this.floorFlat == null || this.floorTotal == null) {
                    return 'nothing';
                } else if (this.floorFlat <= 0) {
                    return 'cellar';
                } else if (this.floorFlat == 1) {
                    return 'ground';
                } else if (this.floorFlat === this.floorTotal) {
                    return 'top';
                } else {
                    return 'middle';
                }
            },

            required: function () {
                return true;
            }
        },

        mounted: function () {
            let data = this.$parent.oldData;

            this.floorFlat = data.floor;
            this.floorTotal = data.total_floors;
        }
    }
</script>

<style scoped>
    .flex-wrapper .form-group:last-of-type {
        margin-bottom: 0 !important;
    }

    .focused-input-image object {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translateX(-50%);
    }

    @media (max-width: 767px) {
        .focused-input-image {
            margin-top: 15px;
        }
        .focused-input-image object {
            position: relative;
            top: 0;
            left: 0;
            transform: none;
        }
    }
</style>
